import React, {useState} from 'react';
import {QUOTE_PAGES} from "../JobQuotePage";
import {toast} from "react-toastify";
import Card from "../../components/Card";
import CreateEditQuote from "../../components/job/quote/CreateEditQuote";

const JobQuoteCreateEditPage = (props) => {
    const {
        jobId           = null,
        quoteId         = null,
        parentId        = "",
        onChangePage    = (INDEX, quote) => {}
    } = props;

    const handleClickBack = (event) => {
        event.preventDefault();
        onChangePage(QUOTE_PAGES.INDEX, null);
    }

    const handleCancel = () => {
        onChangePage(QUOTE_PAGES.INDEX, null);
    }

    const handleComplete = (quote) => {
        if (!!quoteId) {
            toast.success(<div>{"Quote updated."}</div>);
        } else {
            toast.success(<div>{"Quote created."}</div>);
        }

        onChangePage(QUOTE_PAGES.INDEX, null);
    }

    const handleDelete = () => {
        toast.success(<div>{"Quote deleted."}</div>);

        onChangePage(QUOTE_PAGES.INDEX, null);
    }

    return (
        <React.Fragment>
            <Card
                title={!!quoteId ? "Edit Quote" : "Create Quote"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'quote') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <CreateEditQuote
                    jobId={jobId}
                    quoteId={quoteId}
                    onCancel={() => handleCancel()}
                    onComplete={(quote) => handleComplete(quote)}
                    onDelete={() => handleDelete()}
                    parentId={parentId}
                />
            </Card>
        </React.Fragment>
    );
}

export default JobQuoteCreateEditPage;
